<template>
  <div ref="navigatContainer" class="scroll-bar-container" v-if="data && data.length">
    <div ref="navigatScroll" class="navigat-list-scroll" :class="{'fiexd':isFixed}">
      <ul ref="navigatListWrap" class="jrm-bfc navigat-list-wrap">
        <li v-for="(item, index) in data" :key="index" @click="activeItem(item, index)" class="J_ping" :class='{navigativeActive:index==currentIndex }' :clstag="'jr|keycount|yxsc_home_Categorys|'+index+''" report-eventid="MInterestFree_LikeTab" :report-eventparam="index">
          <p>{{item.title}}</p>
          <p :class='{lineP:index==currentIndex }'></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll-patch';
export default {
  name: 'NavigaterBarScroll',
  props: {
    data: {
      type: Array,
      default: null
    },
    /**
     * 当数据更新后，刷新scroll的延时。
     */
    refreshDelay: {
      type: Number,
      default: 20
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isFixed: false
    };
  },
  mounted() {
    const win = window;
    const requestAniFrame = this.requestAniFrame();
    let scheduledAniFrame = false;

    const stt = setTimeout(() => {
      clearTimeout(stt);
      win.addEventListener('scroll', () => {
        if (scheduledAniFrame) return;
        scheduledAniFrame = true;
        requestAniFrame(() => {
          scheduledAniFrame = false;
          this.getRect();
          if (this.rect) {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.fiexdTop = Math.abs(this.rect.top) - 15;
            if (this.scrollTop > window.innerHeight && this.scrollTop >= this.fiexdTop) {
              console.log(this.scrollTop, this.fiexdTop);
              this.isFixed = true;
            } else {
              this.isFixed = false;
            }
          }
        });
      });
    }, 300);
  },
  methods: {
    _initScroll() {
      this.slideWidth();
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs.navigatContainer, {
          scrollY: false,
          scrollX: true,
          click: true,
          bounce: false,
          probeType: 2
        });

        // 是否派发滚动事件
        this.scroll.on('scroll', e => {
          this.$emit('onScroll', e);
        });

        // 是否派发滚动到底部事件，用于上拉加载
        this.scroll.on('scrollEnd', e => {
          this.$emit('onScrollEnd', e);
        });
      });
    },
    refresh() {
      if (!this.scroll) {
        // 保证在DOM渲染完毕后初始化better-scroll
        setTimeout(() => {
          this._initScroll();
        }, 20);
        return;
      }
      this.slideWidth();
      this.$nextTick(() => {
        this.scroll.refresh();
      });
    },
    slideWidth() {
      const maxWidth = $(this.$refs.navigatListWrap).width() + 10;
      if (this.$refs && this.$refs.navigatScroll) {
        this.$refs.navigatScroll.style.width = maxWidth + 'px';
      }
    },
    activeItem(item, index) {
      this.$nextTick(() => {
        this.$emit('onItemClick', { category: item, index });
        if (this.scrollTop >= this.fiexdTop) {
          // $(document).scrollTo(this.fiexdTop);
          if (window.scrollTo) {
            window.scrollTo(0, this.fiexdTop);
          }
        }
      });
    },
    scrollTo(x, y) {
      if (this.scroll) {
        this.scroll.scrollTo(x, y, 1);
      }
    },
    requestAniFrame() {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    },
    getRect() {
      if (this.$refs && this.$refs.navigatContainer) {
        this.rect = $(this.$refs.navigatContainer).offset();
      } else {
        this.rect = null;
      }
    }
  },
  watch: {
    // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
    data() {
      setTimeout(() => {
        this.refresh();
      }, this.refreshDelay);
    }
  },
  destroyed() {
    this.scroll = null;
  }
};
</script>

<style  lang="scss">
@import './../scss/mixin.scss';
.scroll-bar-container {
  width: 100%;
  height: $rem60;
  position: relative;
  overflow: hidden;

  .navigat-list-scroll {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    height: $rem60;
    background: #fff;
    width: 20000px;

    &.fiexd {
      position: fixed;
      padding-top: $rem32;
      height: $rem100;
    }
  }

  .navigat-list-wrap {
    height: 30px;
    float: left;
  }

  .navigat-list-wrap li {
    display: block;
    float: left;
    text-align: center;
    margin-right: $rem48;
    padding-bottom: $rem11;
    cursor: pointer;
    font-family: PingFangSC-Regular;
    font-size: $rem32;
    color: #999999;
    letter-spacing: 0;
  }
  .navigat-list-wrap li:first-child {
    margin-left: $rem24;
  }
  .navigativeActive {
    // border-bottom-width: $rem4;
    // border-bottom-color: #333333;
    // border-style: solid;
    color: #333333 !important;
    font-family: PingFangSC-Medium !important;
  }
  .lineP {
    width: $rem40;
    height: $rem4;
    background: #333333;
    margin: 0 auto;
    margin-top: $rem15;
  }
}
</style>
